// extracted by mini-css-extract-plugin
export var alt = "OccupancyMessage-module--alt--3605a";
export var desktopOnly = "OccupancyMessage-module--desktopOnly--bbc78";
export var main = "OccupancyMessage-module--main--4bdef";
export var mobileOnly = "OccupancyMessage-module--mobileOnly--52051";
export var occupancyInfo = "OccupancyMessage-module--occupancyInfo--9567d";
export var roomOccupancy = "OccupancyMessage-module--roomOccupancy--72f17";
export var textLeft = "OccupancyMessage-module--textLeft--ff822";
export var visuallyHidden = "OccupancyMessage-module--visuallyHidden--a927e";